import {IPlatformApiProvider} from '@shared/services/platform-api-provider';
import {Api} from '@shared/constants/common-field.constants';

export class TransactionTrackerApiProvider implements IPlatformApiProvider {
  getApi(url: string): string {
    if (url.startsWith('/transaction-tracker')) {
      return Api.TransactionTrackerApi;
    }
    return '';
  }

}
